import React, { useState } from "react";
import { Typography, Input, Toastify, toast } from "top-brains-ui";
import styles from "@src/pages/login/forgot-password/ForgotPassword.module.scss";
import { useNavigate } from "react-router-dom";
import { useForgotPasswordMutation } from "@src/api/LoginApiSlice";
import GradiantButton from "@src/components/gradiant-btn/GradiantButton";
import { useDispatch } from "react-redux";
import { setUserLogin } from "@src/app/globalSlice";
import CommonLoader from "@src/components/loader/CommonLoader";
import { COMMON_COLORS } from "@src/styles/ColorConstants";

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");
  const navigate = useNavigate();
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();
  const dispatch = useDispatch();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);

    if (!value) {
      setError(true);
      setHelperText("Email is required.");
    } else if (!/\S+@\S+\.\S+/.test(value)) {
      setError(true);
      setHelperText("Please enter a valid email address.");
    } else {
      setError(false);
      setHelperText("");
    }
  };
  const handleSignInClick = () => {
    navigate("/");
    dispatch(setUserLogin(true));
  };

  const handleResetLink = async () => {
    if (!email || error) {
      toast.error("Please enter a valid email address.");
      return;
    }

    try {
      await forgotPassword({ email }).unwrap();
      navigate("/resent-password-link", {
        state: { email },
      });
    } catch (err) {
      const error = err as { data?: { response?: string } };
      toast.error(error?.data?.response || "Something went wrong");
      console.error("Error sending reset link:", error);
    }
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.cardContainer}>
          <div className={styles.card}>
            <div className={styles.msgTitle}>
              <Typography
                fontWeight="semi-bold"
                fontSize={24}
                color="var(--modal-heading-color)"
                className={styles.forgotPassword}
              >
                Forgot Password?
              </Typography>
              <div>
                <Typography
                  fontSize={12}
                  color="var(--modal-sub-heading-color)"
                  fontWeight="medium"
                  className={styles.description}
                >
                  Please provide the email address that you used when you signed
                  up for your account
                </Typography>
              </div>
            </div>
            <div className={styles.emailField}>
              <Input
                type="email"
                label="Email"
                name="email"
                value={email}
                variant="website"
                onChange={handleChange}
                required
                error={error}
                helperText={helperText}
              />
            </div>
            <div className={styles.subText}>
              <Typography
                fontSize={16}
                color="var(--modal-sub-heading-color)"
                fontWeight="medium"
              >
                We will send you an email that will allow you to reset your
                password
              </Typography>
            </div>
          </div>
          <div className={styles.resendBtn}>
            <GradiantButton
              variant="secondary"
              labelClassName={styles.backButton}
              className={styles.backButtonClass}
              onClick={handleSignInClick}
              label="Back to Sign In"
              fontSize={16}
              width="192px"
              height="44px"
            />
            <GradiantButton
              variant="primary"
              className={styles.backButtonClass}
              labelClassName={styles.sendButton}
              onClick={handleResetLink}
              disabled={!email || error}
              label="Send reset link"
              fontSize={16}
              width="192px"
              height="44px"
            />
          </div>
          {isLoading && (
            <CommonLoader
              color={COMMON_COLORS.WEBSITE_GREEN_LIGHT}
              overLayColor={COMMON_COLORS.LOADER_OVERLAY}
            />
          )}
        </div>
      </div>
      <Toastify />
    </>
  );
};

export default ForgotPassword;
